import { withBase, joinURL, parseURL } from 'ufo'

// https://www.storyblok.com/docs/image-service
const storyblockCDN = 'https://a.storyblok.com'

export const getImage = (
  src,
  { modifiers = {}, baseURL = storyblockCDN } = {}
) => {
  const {
    fit,
    smart,
    width = '0',
    height = '0',
    filters = {},
    format,
    quality,
  } = modifiers

  const doResize = width !== '0' || height !== '0'

  if (format) {
    filters.format = format + ''
  }

  if (quality) {
    filters.quality = quality + ''
  }

  const _filters = Object.entries(filters || {})
    .map((e) => `${e[0]}(${e[1]})`)
    .join(':')

  const options = joinURL(
    fit ? `fit-${fit}` : '',
    doResize ? `${width}x${height}` : '',
    smart ? 'smart' : '',
    _filters ? 'filters:' + _filters : ''
  )

  // TODO: check if hostname is https://a.storyblok.com ?
  const { pathname } = parseURL(src)

  // don't merge options if svg
  // SVG (Scalable Vector Graphics) can’t be cropped, resized, or optimized since they can be scaled automatically.
  const url = withBase(
    pathname.includes('svg') ? pathname : joinURL(`${pathname}/m/`, options),
    baseURL
  )

  return {
    url,
  }
}
